import { useSelect } from "@refinedev/antd";
import { IProject } from "interfaces";
import { APP_WRITE_PROEJCT_ID } from "utility/constants";

export const ProjectSelectOptions = () => {
  const { selectProps: projectSelectProps } = useSelect<IProject>({
    resource: APP_WRITE_PROEJCT_ID,
    optionLabel: "name",
    optionValue: "id",
    sorters: [
      {
        field: "name",
        order: "asc",
      },
    ],
  });
  return (
    {projectSelectProps}
  );
};